import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '../../../components/ui/card';
import { Skeleton } from '../../../components/ui/skeleton';
import { IconChartArcs3 } from '@tabler/icons-react';
import { cn } from '../../../lib/utils';
import drugSearchAnalyticService from '../../../services/drug-search-analytics.service';

const DrugSearchToCoverageInsightsCard = ({ filters }) => {
  const [insights, setInsights] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const formatDuration = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    if (minutes > 0) {
      return `${minutes} min${minutes > 1 ? 's' : ''} ${seconds} sec`;
    }
    return `${seconds} sec`;
  };

  useEffect(() => {
    const fetchInsights = async () => {
      setError(false);
      setLoading(true);
      try {
        const data =
          await drugSearchAnalyticService.getDrugSearchToCoverageInsights({
            ...filters,
          });
        setInsights(data);
        setError(null);
      } catch (err) {
        console.error('Error fetching insights:', err);
        setError('Failed to load search to coverage insights.');
        setInsights(null);
      } finally {
        setLoading(false);
      }
    };

    if (filters) {
      fetchInsights();
    }
  }, [filters]);

  return (
    <Card className="shadow-sm border-0">
      <CardContent className="pt-6">
        <div className="flex justify-between items-center mb-3">
          <div
            className={cn(
              'p-2 rounded',
              loading ? 'bg-gray-100' : 'bg-blue-500 text-white'
            )}
            style={{ width: 40, height: 40 }}
          >
            <IconChartArcs3 size={24} />
          </div>
          {loading && <Skeleton className="w-[60px] h-5" />}
        </div>

        <h5 className="text-lg font-bold mb-2">Search to Coverage Insights</h5>

        {error ? (
          <div className="text-red-600 text-center font-semibold py-3">
            {error}
          </div>
        ) : (
          <div className="flex justify-between">
            <div>
              <p className="text-muted-foreground text-sm mb-1">Avg. Time to Coverage Check</p>
              <h5 className="text-xl font-semibold">
                {loading ? (
                  <Skeleton className="w-20 h-6" />
                ) : (
                  formatDuration(insights.average_time_difference_ms)
                )}
              </h5>
            </div>

            <div>
              <p className="text-muted-foreground text-sm mb-1">Search to Coverage Ratio</p>
              <h5 className="text-xl font-semibold">
                {loading ? (
                  <Skeleton className="w-20 h-6" />
                ) : (
                  `${insights?.search_to_coverage_ratio ?? '-'}`
                )}
              </h5>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default DrugSearchToCoverageInsightsCard;
